import React from 'react'

export const VFQuestion = ({id,defChk,text_value,correct}) => {

      if(defChk===1){
        return (
            <label className="btn btn-secondary active" key={`r${id}`}><input name="options" type="radio" key={id} id={id} className="opt-question" value={correct} />{" "} {text_value} </label>
        )
      }
      else{
        return (
            <label className="btn btn-secondary active" key={`r${id}`}><input name="options" type="radio" key={id} id={id} className="opt-question" value={correct} />{" "} {text_value} </label>
        )
      }
    
}
